import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Brain, LogOut } from "lucide-react";

const roleLabel = { alumno: "Alumno", supervisor: "Supervisor", admin: "Administrador" };

export function AppShell({ children, title, right }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-40 border-b border-border bg-white/90 backdrop-blur">
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-6">
          <button
            className="flex items-center gap-3"
            onClick={() => navigate("/")}
            data-testid="brand-home-button"
          >
            <div className="flex h-9 w-9 items-center justify-center rounded-md bg-primary text-primary-foreground">
              <Brain className="h-5 w-5" />
            </div>
            <div className="text-left leading-tight">
              <p className="font-display text-sm font-bold text-foreground">Centro de Psicoterapia Cognitiva</p>
              <p className="text-xs text-muted-foreground">Simulador Educativo · SEPP</p>
            </div>
          </button>
          <div className="flex items-center gap-4">
            {right}
            {user && (
              <div className="flex items-center gap-3">
                <div className="text-right leading-tight">
                  <p className="text-sm font-medium text-foreground">{user.name || user.matricula || user.email}</p>
                  <p className="text-xs uppercase tracking-wider text-primary">{roleLabel[user.role]}</p>
                </div>
                <Button variant="ghost" size="icon" onClick={() => { logout(); navigate("/"); }} data-testid="logout-button">
                  <LogOut className="h-4 w-4" />
                </Button>
              </div>
            )}
          </div>
        </div>
      </header>
      {title && (
        <div className="border-b border-border bg-white">
          <div className="mx-auto max-w-7xl px-6 py-5">
            <h1 className="font-display text-2xl font-bold tracking-tight text-foreground">{title}</h1>
          </div>
        </div>
      )}
      <main className="mx-auto max-w-7xl px-6 py-8">{children}</main>
    </div>
  );
}
